import React, { Suspense, lazy } from 'react';
const LazyPurchaseToast = lazy(() => import('./PurchaseToast').then(m => ({
  default: m.PurchaseToast
})));
export function Hero() {
  return <section className="relative bg-transparent text-slate-900 flex flex-col items-center justify-start md:justify-center px-4 pt-4 md:pt-12 pb-2 md:py-20 overflow-hidden font-sans" data-id="element-102">
      {/* Brand Header */}
      <div className="flex items-center gap-2 mb-1 md:mb-4" data-id="element-103"></div>

      {/* Mini Testimonials / Social Proof */}

      {/* Main Title */}
      <h1 className="text-4xl md:text-7xl lg:text-8xl font-black text-center max-w-5xl leading-[1] mb-2 md:mb-12" data-id="element-104">
        Física en Acción <br data-id="element-105" />
        <span className="text-blue-600 text-[24px]" data-id="element-106">
          Tu año resuelto en menos de 30 minutos.
        </span>
      </h1>

      {/* Product Visual Mockup */}
      <div className="relative w-full max-w-[260px] md:max-w-[500px] mb-2 md:mb-12" data-id="element-107">
        <img src="https://cdn.magicpatterns.com/uploads/sResd856pT4nEBtm8skGQ7/fisica_en_accion_mockup_optimized.webp" alt="Megapack Física en Acción Mockup" width={1080} height={1080} fetchPriority="high" loading="eager" decoding="async" className="w-full h-auto" data-id="element-108" />
      </div>

      {/* Quote and Sub-headline */}
      <div className="text-center space-y-1 mb-3 md:mb-10 max-w-2xl animate-fade-in" data-id="element-109">
        <p className="text-blue-700 italic md:text-2xl font-medium px-2 text-[14px]" data-id="element-110">
          "Planificación completa para educación secundaria, organizada de 1.º a
          6.º año o niveles equivalentes. Incluye actividades, evaluaciones,
          experimentos de bajo costo y proyectos completos para ferias de
          ciencias."
        </p>
        <p className="text-slate-600 text-xs md:text-xl font-bold" data-id="element-111">
          7 Tomos + 3 Bonos + Bóveda VIP
        </p>
      </div>

      {/* CTA Button */}
      <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} className="w-full max-w-xs md:max-w-none bg-green-500 hover:bg-green-600 active:scale-95 text-white font-black text-lg md:text-2xl py-4 md:py-5 px-6 md:px-10 rounded-2xl shadow-[0_0_20px_rgba(34,197,94,0.4)] flex items-center justify-center gap-3 transition-all mb-4 md:mb-12 animate-fade-in btn-neon" data-id="element-112">
        <span data-id="element-113">⚗️</span>
        <span className="text-[16px]" data-id="element-114">QUIERO DESCARGARLO YA</span>
      </button>

      {/* Trust Badges */}
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-12 text-[9px] md:text-base font-bold text-slate-500 animate-fade-in" data-id="element-115">
        <div className="flex items-center gap-2" data-id="element-116">
          <span className="text-xl" data-id="element-117">📄</span> 100% PDF
        </div>
        <div className="flex items-center gap-2" data-id="element-118">
          <span className="text-xl" data-id="element-119">⚡</span> Acceso inmediato
        </div>
        <div className="flex items-center gap-2" data-id="element-120">
          <span className="text-xl" data-id="element-121">🌎</span> Disponible en toda Latinoamérica
        </div>
      </div>

      {/* Floating Notification - Lazy Loaded */}
      <Suspense fallback={null} data-id="element-122">
        <LazyPurchaseToast data-id="element-123" />
      </Suspense>
    </section>;
}